export { default } from './RecommendedCarousels';
